// extracted by mini-css-extract-plugin
module.exports = {"container":"Alerts_container__1GOb2","title":"Alerts_title__2SU2m"};